import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const TryOnIFrame = styled.iframe`
	width: 100%;
	height: 100%;
	border: none;
	outline: none;
`;

export interface TryOnFrameProps {
	className?: string;
	providerUrl: string;
	providerTitle: string;
	outMessageHandler: (e: MessageEvent<any>) => void;
	onReady?: (w: Window) => void;
	children?: React.ReactNode;
}
// #region common frame
export const TryOnFrame: FunctionComponent<TryOnFrameProps> = (props) => {
	const frame = useRef(null);
	const [eventAdded, setEventAdded] = useState(false);

	const [timeOut, setTimeOut] = useState(null as any);
	const [lockForTimeOut, setLockForTimeOut] = useState(false);

	const pdToolFrame: HTMLIFrameElement = frame?.current as unknown as HTMLIFrameElement;
	const windowFineTuning = pdToolFrame?.contentWindow as unknown as Window;

	const startTimeOut = () => {
		if (timeOut) clearTimeout(timeOut);
		setLockForTimeOut(true);
		pdToolFrame?.setAttribute('src', 'about:blank');
		setTimeOut(
			setTimeout(() => {
				setLockForTimeOut(false);
				pdToolFrame?.setAttribute('src', props.providerUrl);
			}, 1500)
		);
	};

	useEffect(() => {
		if (pdToolFrame && windowFineTuning) {
			props.onReady && props.onReady(windowFineTuning);
			startTimeOut();
		}
	}, [windowFineTuning]);

	useEffect(() => {
		if (!eventAdded) {
			setEventAdded(true);
			window.addEventListener('message', props.outMessageHandler);
		}
		return () => {
			if (eventAdded) {
				window.removeEventListener('message', props.outMessageHandler);
				setEventAdded(false);
			}
		};
	}, []);

	return (
		<TryOnIFrame
			ref={frame}
			className={props.className ? props.className : '' + ' tryon-' + props.providerTitle + '-frame'}
			src='about:blank'
			scrolling='no'
			allowFullScreen={true}
			allow='accelerometer; magnetometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;'
		/>
	);
};

// #endregion
